module.exports = __webpack_public_path__ + "static/media/mausam - strong surface winds.33747670.png";